import type { Timezone} from "@@/shared/date-time/timezone";
import { timezoneZodType } from "@@/shared/date-time/timezone";
import type { OwnerId} from "@@/shared/owner-id";
import { ownerIdZodSchema } from "@@/shared/owner-id";
import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import type { SystemUser} from "@@/shared/users/system-user";
import { systemUserZodSchema } from "@@/shared/users/system-user";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type {
    IsoAndUnixTimestamp} from "../../date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "../../date-time/iso-and-unix";
import type { TimeRange} from "../../date-time/time-range";
import { timeRangeZodSchema } from "../../date-time/time-range";
import type { ReportId} from "../report-id";
import { reportIdZodSchema } from "../report-id";

type _ReportBase = {
    readonly _id: ReportId;
    readonly _type: "REPORT";
    readonly _creatorId: UserId | SystemUser;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly timeRange: TimeRange;
    readonly timezone: Timezone;
    readonly title: Translatable;
    readonly description?: Translatable;
    readonly ownerId: OwnerId;
};

const _reportBaseZodSchema: z.ZodSchema<_ReportBase> = z.object({
    _id: reportIdZodSchema,
    _type: z.literal("REPORT"),
    _creatorId: z.union([userIdZodSchema, systemUserZodSchema]),
    _createdAt: isoAndUnixZodSchema,
    timeRange: timeRangeZodSchema,
    timezone: timezoneZodType,
    title: translatableZodSchema,
    description: translatableZodSchema.optional(),
    ownerId: ownerIdZodSchema,
});

export { _reportBaseZodSchema };
export type { _ReportBase };
